import { z } from 'zod';

import { ComponentValidator, ComponentPayloadValidator } from '../Component';

import { AbstractPort, Port } from '../fields/AbstractPort';

import { ComponentDefinition } from '../../types/ComponentDefinition';

const port = AbstractPort.extend({
    DC: Port.DC.default({}),
    capacitance: Port.capacitance.validator,
    equivalentSeriesResistance: Port.equivalentSeriesResistance.validator,
    reverseDiode: z.boolean().default(false),
    powerFlowDirection: Port.powerFlowDirection.literals.bidirectional,
}).default({});

const CapacitorBase = z.object({
    type: z.literal('capacitor').default('capacitor'),
    electrical: z
        .object({
            ports: z.tuple([port]).default([undefined]),
        })
        .default({}),
});

export const CapacitorValidator = ComponentValidator.merge(CapacitorBase);
export const CapacitorPayloadValidator = ComponentPayloadValidator.merge(CapacitorBase);

export const CapacitorDefinition: ComponentDefinition = {
    type: 'capacitor',
    name: 'Capacitor',
    plural: 'Capacitors',
    indicator: 'C',
    hasDynamicNumberOfPorts: false,
    interoperabilityDataModel: false,
    ports: {
        min: 1,
        max: 1,
        powerFlowDirections: ['bidirectional'],
    },
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: CapacitorValidator,
        payload: CapacitorPayloadValidator,
    },
};

export type Capacitor = z.infer<typeof CapacitorValidator>;
export type CapacitorPayload = z.infer<typeof CapacitorPayloadValidator>;
